import { getMapDimensionsForSetting } from 'mapping/index';
import { CRS, Transformation } from 'leaflet';
import getMapZoomLimitsForSetting from 'mapping/getMapZoomLimitsForSetting';
import { IMappableSetting } from 'types/map';

export default function getCRSForSetting(setting: IMappableSetting) {
  const { width: mapWidth, height: mapHeight } = getMapDimensionsForSetting(setting);
  const { max: mapMaxZoom } = getMapZoomLimitsForSetting(setting);

  const tileExtent = [0, -mapHeight, mapWidth, 0];

  const mapMaxResolution = 1.0;
  const mapMinResolution = Math.pow(2, mapMaxZoom) * mapMaxResolution;

  const crs = {
    ...CRS.Simple,
    transformation: new Transformation(1, -tileExtent[0], -1, tileExtent[3]),
  };
  crs.scale = (zoom) => Math.pow(2, zoom) / mapMinResolution;
  crs.zoom = (scale) => Math.log(scale * mapMinResolution) / Math.LN2;

  return crs;
}